import { createReducer, on } from '@ngrx/store';
import { ImpersonationActions } from '@ps/auth-data-access';

import { INITIAL_REFERENCE_STATE } from '../survey-state.constants';
import {
  BulkEditActions,
  BulkEditApiActions,
} from '../bulk-edit/bulk-edit.actions';
import {
  SurveyReferenceActions,
  SurveyReferenceApiActions,
} from './survey-reference.actions';

export const surveyReferenceReducer = createReducer(
  INITIAL_REFERENCE_STATE,

  on(
    SurveyReferenceApiActions.loadBuyerManagersSuccess,
    (state, { managers, cachedAt }) => ({
      ...state,
      buyerProjectManagers: managers,
      buyerPmCachedAt: cachedAt,
    }),
  ),

  on(SurveyReferenceApiActions.loadBuyerManagersFailure, (state) => ({
    ...state,
    buyerProjectManagers: [],
  })),

  on(
    SurveyReferenceApiActions.loadOperatorManagersSuccess,
    (state, { managers, cachedAt }) => ({
      ...state,
      operatorProjectManagers: managers,
      operatorPmCachedAt: cachedAt,
    }),
  ),

  on(SurveyReferenceApiActions.loadOperatorManagersFailure, (state) => ({
    ...state,
    operatorProjectManagers: [],
  })),

  on(
    SurveyReferenceApiActions.loadTransactionStatusesSuccess,
    (state, { statuses, cachedAt }) => ({
      ...state,
      transactionStatuses: statuses,
      transactionStatusesCachedAt: cachedAt,
    }),
  ),

  on(SurveyReferenceApiActions.loadTransactionStatusesFailure, (state) => ({
    ...state,
    transactionStatuses: [],
  })),

  on(
    SurveyReferenceApiActions.loadBuyerSettingsSuccess,
    (state, { buyerSettings, cachedAt }) => ({
      ...state,
      buyerSettings,
      buyerSettingsCachedAt: cachedAt,
    }),
  ),

  on(SurveyReferenceApiActions.loadBuyerSettingsFailure, (state) => ({
    ...state,
    buyerSettings: null,
  })),

  on(SurveyReferenceActions.downloadCombinedSTReport, (state) => ({
    ...state,
    isDownloadingSurveyReport: true,
  })),

  on(SurveyReferenceApiActions.downloadCombinedSTReportSuccess, (state) => ({
    ...state,
    isDownloadingSurveyReport: false,
  })),

  on(SurveyReferenceApiActions.downloadCombinedSTReportFailure, (state) => ({
    ...state,
    isDownloadingSurveyReport: false,
  })),

  on(BulkEditActions.getSupplierSummaryReport, (state) => ({
    ...state,
    isDownloadingSupplierSummary: true,
  })),

  on(BulkEditApiActions.downloadSupplierSummaryReportSuccess, (state) => ({
    ...state,
    isDownloadingSupplierSummary: false,
  })),

  on(BulkEditApiActions.downloadSupplierSummaryReportFailure, (state) => ({
    ...state,
    isDownloadingSupplierSummary: false,
  })),

  on(SurveyReferenceActions.downloadCsReport, (state) => ({
    ...state,
    isDownloadingCsReport: true,
  })),

  on(SurveyReferenceApiActions.downloadCsReportSuccess, (state) => ({
    ...state,
    isDownloadingCsReport: false,
  })),

  on(SurveyReferenceApiActions.downloadCsReportFailure, (state) => ({
    ...state,
    isDownloadingCsReport: false,
  })),

  on(ImpersonationActions.contextSettled, () => INITIAL_REFERENCE_STATE),
);
